/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import OneStopButtonsLayout from './OneStopButtonsLayout';

type OneStopPageLayoutProps = {
  children: React.ReactElement[] | React.ReactElement;
};

const OneStopPageLayout = ({ children }: OneStopPageLayoutProps) => {
  return (
    <>
      <Box className="one-stop-page" position="relative">
        {children}
      </Box>
      <OneStopButtonsLayout isFixed={false} />
    </>
  );
};

export default OneStopPageLayout;
